import config from '../Config';
import http from '../Http';
import { useState } from 'react';
import { Modal, Button, Upload  } from 'antd';
import { useTranslation } from 'react-i18next';

function DeviceTransfer (props) {
    const {show, onClose} = props;
    const { t } = useTranslation();

    const [resultCode, setResultCode] = useState("")
    const [resultMsg, setResultMsg] = useState("")

    const handleCancle = () => {
        onClose();
    }

    const handleOK = () => {
        onClose();
    }

    const handleChange = async ({file}) => {
        console.log("--->", file);
        if (file.status === "error") {
            setResultCode(441);
            setResultMsg(t("error"));
            return;
        } 
        if (file.status !== "done" || file.response == null) {
            setResultMsg("");
            return;
        }
        const resp = file.response;
        setResultCode(resp.code);
        if (resp.code !== 200) {
            setResultMsg(resp.msg || "error");
        } else {
            setResultMsg(resp.msg || t("Transfer OK"));
        }
    }

    return (<Modal 
        title={t("Transfer Devices")}
        visible={show}
        cancelText={t("Cancel")}
        okText={t("OK")}
        mask={true}
        maskClosable={false}
        width={600}
        onCancel={handleCancle}
        onOk={handleOK}
        footer={[
            <Button key="Cancel" onClick={handleCancle}>{t("Cancel")}</Button>,
            <Button key="OK" type="primary" onClick={handleOK}>{t("OK")}</Button>
        ]}
    >
        <div style={{
            display: "flex",
            flexDirection: "column",
        }}>
            <div style={{
                flex: "0 0 auto",
                color: "red",
            }}>
                {t("Please fill out your uploading file by The Template File:")}<a href={config.apiUrl+"device/management/transfer/xls-template/get?Token="+http.token} style={{fontWeight:700}}>{t("Devices-Transfer.xls")}</a>. 
            </div>
            <div style={{flex: "0 0 30px"}}></div>
            <Upload 
                maxCount={1}
                accept=".xlsx,.xlsm,.xltm,.xltx"
                name="Devices-Transfer.XLS"
                action={config.apiUrl+"device/management/transfer/do"}
                headers={{Token:http.token}}
                showUploadList={{showRemoveIcon:false}}
                onChange={handleChange}
            >
                <Button>{t("Choose Data File (XLSX,XLSM,XLTM,XLTX) to Transfer")}</Button>
            </Upload>
            <div style={{
                flex: "1 1 auto",
                color: resultCode === 200 || resultCode === "200" ? "green": "red"
            }}>{resultMsg}</div>
        </div>
    </Modal>);
}

export default DeviceTransfer;